import React, { Component, Fragment } from "react";
import { Line } from "react-chartjs-2";
import { translate } from "react-multi-lang";
import compose from "compose-function";
import { Card } from "reactstrap";
import PropTypes from "prop-types";

class LineChartComponent extends Component {
  constructor(props) {
    super(props);
    const primaryColor = "rgba(137,57,125,1)";
    const primaryHoverColor = "rgba(137,57,125,0.85)";
    const secondaryColor = "rgba(44,44,44,0.85)";
    const secondaryHoverColor = "rgba(44,44,44,0.7)";
    this.state = {
      singleLineChartData: {
        labels: this.props.labels,
        datasets: [
          {
            label: this.props.title,
            fill: false,
            lineTension: 0.1,
            backgroundColor: primaryColor,
            borderColor: primaryColor,
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: primaryColor,
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: primaryHoverColor,
            pointHoverBorderColor: primaryHoverColor,
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: this.props.data
          }
        ]
      },
      multiLineChartData: {
        labels: this.props.labels,
        datasets: [
          {
            data: this.props.data1,
            backgroundColor: primaryColor,
            hoverBackgroundColor: primaryHoverColor,
            label: "Open Tickets",
            fill: false,
            lineTension: 0.1,
            borderColor: primaryColor,
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: primaryColor,
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: primaryHoverColor,
            pointHoverBorderColor: primaryHoverColor,
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10
          },
          {
            data: this.props.data2,
            backgroundColor: secondaryColor,
            hoverBackgroundColor: secondaryHoverColor,
            label: "Closed Tickets",
            fill: false,
            lineTension: 0.1,
            borderColor: secondaryColor,
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: secondaryColor,
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: secondaryHoverColor,
            pointHoverBorderColor: secondaryHoverColor,
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10
          }
        ]
      }
    };
  }

  //   componentDidMount() {
  //     const { datasets } = this.refs.chart.chartInstance.data;
  //     console.log(datasets);
  //   }
  render() {
    return (
      <Fragment>
        <Card id="chart" className="p-2">
          <Line
            data={
              this.props.isMulti
                ? this.state.multiLineChartData
                : this.state.singleLineChartData
            }
            height={this.props.isMulti ? 80 : 150}
            options={{
              title: {
                display: true,
                text: this.props.isMulti
                  ? "Open Tickets Vs Closed Tickets"
                  : `${this.props.subTitle} :${this.props.totalValue}`,
                fontSize: 15,
                fontColor: "#2c2c2c",
                position: "bottom"
              },
              legend: {
                display: true,
                position: "top",
                labels: {
                  fontColor: "#2c2c2c"
                }
              },
              scales: {
                xAxes: [
                  {
                    ticks: {
                      fontColor: "#2c2c2c"
                    },
                    gridLines: {
                      color: "rgba(44,44,44,0.08)"
                    }
                  }
                ],
                yAxes: [
                  {
                    ticks: {
                      fontColor: "#2c2c2c"
                    },
                    gridLines: {
                      color: "rgba(44,44,44,0.08)"
                    }
                  }
                ]
              }
            }}
          />
        </Card>
      </Fragment>
    );
  }
}

LineChartComponent.propTypes = {
  t: PropTypes.func
};

export default compose(translate)(LineChartComponent);
